import { render, staticRenderFns } from "./OrderDetailTable.vue?vue&type=template&id=7a48314a&"
import script from "./OrderDetailTable.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailTable.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports